var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#198754",
    d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#198754",
    d: "M12.707,5.293a1,1,0,0,0-1.414,0l-4,4a1,1,0,1,0,1.414,1.414L11,8.414V18a1,1,0,0,0,2,0V8.414l2.293,2.293a1,1,0,0,0,1.414-1.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionGreen);
export default __webpack_public_path__ + "static/media/directionGreen.dd3062bd0d9bb24defb1e07dd52f7ff5.svg";
export { ForwardRef as ReactComponent };